import React from 'react';
import { Icon as AbyssIcon } from '@uhg-abyss/web/ui/Icon';

export const Icon = (props) => {
  return <AbyssIcon color="UHC_CTA_BLUE" {...props} />;
};
